import { namespace } from '../../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Chain multiple config builders and merge their results
 */
export default class ChainConfigBuilder {
    chainedBuilders = [];

    /**
     * Inititalizes the builder instance.
     *
     * @constructor
     * @param {Object[]} builders
     */
    constructor(builders) {
        this.chainedBuilders = builders || [];
    }

    /**
     * @param {Object} config
     * @param {Ofcs.Editor.Context.Context} [context]
     *
     * @return {Object}
     */
    build(config, context) {
        return this.chainedBuilders
            .filter(builder => builder.supports(context))
            .reduce((reducedConfig, builder) => builder.build(reducedConfig, context), config);
    }

    /**
     * @param {Ofcs.Editor.Context.Context} [context]
     *
     * @return {boolean}
     */
    supports(context) {
        return this.chainedBuilders
            .filter(builder => builder.supports(context)).length > 0;
    }
}

namespace('Ofcs.Editor.Item.ConfigBuilder');
window.Ofcs.Editor.Item.ConfigBuilder.ChainConfigBuilder = ChainConfigBuilder;
